<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                From Name
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                From Email
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                BCC Email
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Reply To Email
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Server Api Token
              </th>

              <th scope="col" class="relative px-6 py-3">
                <span class="sr-only">Edit</span>
              </th>
            </tr>
            </thead>
            <tbody v-if="emailSettings">
            <tr
                v-on:click="handleUpdateEmailSetting(emailSetting)"
                class="hover:bg-gray-100 cursor-pointer"
                v-for="(emailSetting, emailSettingIdx) in emailSettings"
                :key="emailSetting.id"
                :class="emailSettingIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
              <!--              <template v-if="emailSetting.id === clientId">-->
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ emailSetting.fromName }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ emailSetting.fromEmail }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ emailSetting.bccEmail }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ emailSetting.replytoEmail }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ emailSetting.serverApiToken }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <is-manager>
                  <button
                      @click.stop="() => { activeSetting = emailSetting; dangerModalIsOpen = true }"
                      class="text-red-500 hover:text-red-900">
                    Delete
                  </button>
                </is-manager>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <danger-modal
        :open="dangerModalIsOpen"
        title="Are you sure you want to destroy this email setting?"
        content="This action CANNOT be undone."
        cancel-button-text="Cancel"
        action-button-text="Destroy"
        v-on:modal:cancel="() => { dangerModalIsOpen = false; activeSetting = null }"
        v-on:modal:perform="handleDeleteEmailSetting" />
  </div>
</template>

<script>
import DangerModal from '@/components/Functional/Modal/DangerModal'
import IsManager from "@/components/Authorization/IsManager";

export default {
  name: "EmailSettingsTable",
  components: {
    IsManager,
    DangerModal
  },
  props: [
    "emailSettings",
    "clientId",
    "editCallback"
  ],
  data() {
    return {
      dangerModalIsOpen: false,
      activeSetting: null
    }
  },
  methods: {
    async handleUpdateEmailSetting(emailSetting) {
      this.$store.dispatch('showLoadingSpinner')
      if (this.userRole === 'Contributor') return;
      try {
        await this.$store.dispatch('getEmailSetting', emailSetting)
        await this.$store.dispatch('openUpdateEmailSettingPanel')
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')

    },
    async handleDeleteEmailSetting() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('deleteEmailSetting', this.activeSetting)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Email Setting Successfully Deleted'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
        this.activeSetting = null
        this.dangerModalIsOpen = false;
        this.$store.dispatch('hideLoadingSpinner')
      }
      this.activeSetting = null
      this.dangerModalIsOpen = false;
      this.$store.dispatch('hideLoadingSpinner')

    }
  },
  computed: {
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  }

}
</script>

<style scoped>

</style>
